import axios from 'axios'

// process a completed paypal order
export const processPaypalPayment = async (paymentData) => {
    try {
        return await axios.post(`/api/checkout/paypalpayment`, paymentData)
    } catch (err) {
        return {
            error: true,
            response: err.response,
        }
    }
}
